import InventoryManagement from '~user-pages/Inventory/Management/InventoryManagement'
import MarkProduct from '~user-pages/Inventory/Management/MarkProduct'

import MainReplenishment from '~user-pages/Inventory/Replenishment/MainReplenishment'
import ReplenishmentShipments from '~user-pages/Inventory/Replenishment/ReplenishmentShipments'
import ReplenishmentPlans from '~user-pages/Inventory/Replenishment/ReplenishmentPlans'
import ReplenishmentTroubles from '~user-pages/Inventory/Replenishment/ReplenishmentTroubles'
import ReplenishmentItem from '~user-pages/Inventory/Replenishment/ReplenishmentItem'
import ReplenishmentAddProducts from '~user-pages/Inventory/Replenishment/ReplenishmentAddProducts'

import CreateShipment from '~user-pages/Inventory/Replenishment/Shipment/CreateShipment/CreateShipment'
import ShipmentSummary from '~user-pages/Inventory/Replenishment/Shipment/ShipmentSummary'
import Step1 from '~user-pages/Inventory/Replenishment/Shipment/CreateShipment/Step1'
import Step2 from '~user-pages/Inventory/Replenishment/Shipment/CreateShipment/Step2'
import Step3 from '~user-pages/Inventory/Replenishment/Shipment/CreateShipment/Step3'
import Step4 from '~user-pages/Inventory/Replenishment/Shipment/CreateShipment/Step4'

import MainAddProducts from '~user-pages/Inventory/AddProducts/MainAddProducts'
import SingleProduct from '~user-pages/Inventory/SingleProduct'
import ImportProducts from '~user-pages/Inventory/AddProducts/ImportProducts'
import IntegrateProducts from '~user-pages/Inventory/AddProducts/IntegrateProducts'

import InventoryPlaning from '~user-pages/Inventory/InventoryPlaning'

export default [
    {
        path: 'management',
        name: 'InventoryManagement',
        component: InventoryManagement,
        meta: {
            breadcrumb: {
                text: 'Inventory management'
            }
        }
    },
    /*
     ** TODO: temporary hid for prod
    {
        path: 'replenishment',
        component: MainReplenishment,
        meta: {
            breadcrumb: {
                text: 'Inventory replenishment'
            }
        },
        children: [
            {
                path: '',
                name: 'InventoryReplenishment',
                component: ReplenishmentShipments,
                redirect: {name: 'ReplenishmentShipments'},
                meta: {
                    breadcrumb: {
                        text: 'Inventory replenishment'
                    }
                }
            },
            {
                path: 'shipments',
                name: 'ReplenishmentShipments',
                component: ReplenishmentShipments,
                meta: {
                    breadcrumb: {
                        text: 'Replenishment shipments'
                    }
                }
            },
            {
                path: 'plans',
                name: 'ReplenishmentPlans',
                component: ReplenishmentPlans,
                meta: {
                    breadcrumb: {
                        text: 'Replenishment plans'
                    }
                }
            },
            {
                path: 'troubles',
                name: 'ReplenishmentTroubles',
                component: ReplenishmentTroubles,
                meta: {
                    breadcrumb: {
                        text: 'Replenishment troubles'
                    }
                }
            },
            {
                path: ':parent/:planId',
                name: 'ReplenishmentItem',
                component: ReplenishmentItem,
                meta: {
                    breadcrumb: {
                        // text: 'Create a new shipping plan'
                        getText: route => `View ${route.params.parent} ${route.query.planNumber ? route.query.planNumber : route.params.planId}`,
                    }
                }
            },
            {
                path: ':parent/:planId/shipment-summary',
                name: 'ShipmentSummary',
                component: ShipmentSummary,
                meta: {
                    breadcrumb: {
                        text: 'Shipment‘s Summary',
                        parent: true
                    }
                }
            },
            {
                path: ':parent/:planId/add-products',
                name: 'ReplenishmentAddProducts',
                component: ReplenishmentAddProducts,
                meta: {
                    breadcrumb: {
                        text: 'Add product',
                        parent: true
                    }
                }
            },
            {
                path: 'create-shipment/:planId',
                component: CreateShipment,
                meta: {
                    breadcrumb: {
                        text: 'Create a new shipping plan'
                    }
                },
                children: [
                    {
                        path: '',
                        component: Step1
                    },
                    {
                        path: 'step-1',
                        name: 'Step1',
                        component: Step1
                    },
                    {
                        path: 'step-2',
                        name: 'Step2',
                        component: Step2
                    },
                    {
                        path: 'step-3',
                        name: 'Step3',
                        component: Step3
                    },
                    {
                        path: 'step-4',
                        name: 'Step4',
                        component: Step4
                    },
                ]
            }

        ]
    },
    */
    {
        path: 'planning',
        name: 'InventoryPlaning',
        meta: {
            breadcrumb: {
                text: 'Inventory planing'
            }
        },
        component: InventoryPlaning
    },
    {
        path: 'add-products',
        component: MainAddProducts,
        redirect: {name: 'AddProducts'},
        meta: {
            breadcrumb: {
                text: 'Add products'
            }
        },
        children: [
            {
                path: 'add-products',
                name: 'AddProducts',
                component: SingleProduct,
                meta: {
                    breadcrumb: {
                        text: 'Add product'
                    }
                },
            },
            {
                path: 'import-list',
                name: 'ImportProducts',
                component: ImportProducts,
                meta: {
                    breadcrumb: {
                        text: 'Import products list'
                    }
                }
            },
            {
                path: 'integrate',
                name: 'IntegrateProducts',
                component: IntegrateProducts,
                meta: {
                    breadcrumb: {
                        text: 'Integrate products'
                    }
                }
            },
        ]
    },
    {
        path: 'product/:id',
        name: 'SingleProduct',
        component: SingleProduct
    },
    {
        path: 'print-labels/:id',
        name: 'MarkProduct',
        component: MarkProduct
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/inventory-routes.js